import React from "react";
import { PhoneIcon } from "@heroicons/react/solid";
import { PdfPhoneClick } from "@/components/community/PhoneReveal";

const NeedHelpBanner = () => {
    return (
        <div className="bg-primary-500 py-8 sm:py-12 px-4">
            <div className="max-w-4xl mx-auto text-center">
                <h2 className="text-white text-xl sm:text-2xl lg:text-3xl font-bold font-headline mb-4">
                    NEED HELP FINDING ASSISTED LIVING?
                </h2>
                <p className="text-white text-xl sm:text-2xl mb-8">
                    Talk to a Live Assisted Living Counselor Today!
                </p>

                <a
                    href="tel:6127877533"
                    className="inline-flex items-center gap-3 bg-white hover:bg-gray-100 rounded-full px-3 py-3 shadow-lg"
                    onClick={PdfPhoneClick}
                >
                    <div className="w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center">
                        <PhoneIcon className="w-5 h-5 text-white" />
                    </div>
                    <span className="text-2xl sm:text-2xl font-bold text-primary-500">
                        612-787-7533
                    </span>
                </a>
            </div>
        </div>
    );
};

export default NeedHelpBanner;
